import { FC, memo } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader } from '@netiva/classifieds-ui';

import { useAuth } from '@/hooks';
import { routes } from '@/lib/routes';
import { getLandingPagePath } from '@/lib/storage';

/** OAuth callback. MSAL's redirectUri /auth/callback is the separate redirect bridge page (auth/callback.html). */
export const AuthPage: FC = memo(function AuthPage() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isAuthenticated && !isLoading) {
    // TODO handle return URL
    return <Navigate to={getLandingPagePath() || routes.home()} replace />;
  }

  // Render an empty page during authentication.
  return <Loader isLoading />;
});
